import { render } from "./DetalleCliente.vue?vue&type=template&id=ebfd2a58"
import script from "./DetalleCliente.vue?vue&type=script&lang=js"
export * from "./DetalleCliente.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__